import { useCurrentRole } from './useCurrentRole';

export const useCurrentGroup = () => {
  const currentRole = useCurrentRole();

  if (!currentRole || currentRole.resource_type !== 'Group') {
    return null;
  }

  return currentRole.resource;
};
